<template>
    <div class="col-12 d-flex flex-column gap-4 my-3" v-if="contracts">
        <div class="card">
            <table class="table table-responsive table-bordered tabs-elev-table text-sm">
                <thead>
                    <tr>
                        <th scope="col">{{ $t('Avtale') }}</th>
                        <th class="text-end" scope="col">{{ $t('Elever') }}</th>
                        <th class="text-end" scope="col">{{ $t('Varelinjer') }}</th>
                        <th class="text-end" scope="col">{{ $t('Skyldig') }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="contract in contracts" :key="contract.id" class="cursor-pointer" :class="{ 'active': activeContract === contract.id }" @click="fetchDetailedContractInfo(contract.id)">
                        <td>{{ contract.title }}</td>
                        <td class="text-end">{{ contract.unique_students }}</td>
                        <td class="text-end">{{ contract.total_rows }}</td>
                        <td class="text-end">{{ contract.total_balance }}</td>
                        <td><span class="fa fa-chevron-right"></span></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</template>

<script setup>
import { ref, computed } from 'vue';
import Store from '../../state/accountStore'

const props = defineProps(['contracts'])
const activeContract = ref(null);

const contracts = computed(() => {
    return Store.getContracts();
})

const fetchDetailedContractInfo = (id) => {
    activeContract.value = id;
    Store.init(id);
}
</script>